module.exports = __webpack_public_path__ + "img/search.d65ec305.png";